import noodleApiClient, { ApiDefinition } from '@noodleApi';
import buildPath from '@tsClient/utilities/buildPath';

type ThisApi = ApiDefinition['/form-requests/userWorkflow/:userWorkflowId/autofills/initialValues']['GET'];

type Input = ThisApi['params'] & ThisApi['query'];
type Output = ThisApi['response'];

const getAutofillInitialValue = async ({ referenceId, referenceType, userWorkflowId, questionnaireId }: Input): Promise<Output> => {
  const path = buildPath<ThisApi>('/form-requests/userWorkflow/{userWorkflowId}/autofills/initialValues', { userWorkflowId });
  const data = await noodleApiClient.get(path, {
    params: { questionnaireId, referenceId, referenceType },
  });
  return data.data;
};

export default getAutofillInitialValue;